import axios from "./axios-handler.service";
import { Produto } from "./produtos.service";
const BASE_URL = "/api/HistoricosProdutos";

export interface HistoricoProduto {
  idHistoricoProduto: string;
  idProduto: string;
  codigoFornecedor: string;
  valorVenda: number;
  validoDe: string;
  validoAte: string;
  produto: Produto;
}
export class HistoricosProdutosService {
  static async listarPorIdProduto(
    idProduto: string
  ): Promise<HistoricoProduto[]> {
    const response = await axios.get<HistoricoProduto[]>(
      `${BASE_URL}/ListarPorIdProduto`,
      {
        params: { idProduto },
      }
    );
    return response.data;
  }
  static async obter(idHistoricoProduto: string): Promise<HistoricoProduto> {
    const response = await axios.get<HistoricoProduto>(`${BASE_URL}/Obter`, {
      params: { idHistoricoProduto },
    });
    return response.data;
  }
  static async removerHistorico(idHistoricoProduto: string): Promise<void> {
    const response = await axios.post(`${BASE_URL}/RemoverHistorico`, {
      idHistoricoProduto,
    });
    return response.data;
  }
  static async manterHistoricoProduto(
    historicoProduto: HistoricoProduto
  ): Promise<void> {
    await axios.post(BASE_URL + "/ManterHistoricoProduto", historicoProduto);
  }
}
